module.exports = __webpack_public_path__ + "media/unipod/icon-completion-white-f35a17b2.svg";